import { Directive, ElementRef, OnInit, input } from '@angular/core';
import { DotCMSBasicContentlet } from '@dotcms/types';

import { DomService } from 'ish-core/utils/dom/dom.service';

interface DataSet {
  field: string;
  inode: string;
  'data-inode': string;
  'data-field-name': string;
  mode: string;
  'data-mode': string;
  lang: string;
  'data-language': string;
}

@Directive({
  selector: '[dotCmsUveSetAttributes]',
  providers: [DomService],
  exportAs: 'dotCmsUveSetAttributes',
  standalone: true,
})
export class DotCmsUveSetAttributesDirective implements OnInit {
  constructor(private elementRef: ElementRef, private domService: DomService) {}

  attributes: DataSet;
  // readonly identifier = input<string>(undefined);
  readonly fieldName = input<string>(undefined);
  readonly mode = input<string>(undefined);
  readonly setAttribute = input<boolean>(true);
  readonly contentlet = input<DotCMSBasicContentlet>(undefined);

  ngOnInit(): void {
    if (this.setAttribute() && this.contentlet()) {
      this.attributes = {
        field: this.fieldName(),
        inode: this.contentlet()?.inode,
        'data-inode': this.contentlet()?.inode,
        'data-field-name': this.fieldName(),
        mode: this.mode(),
        'data-mode': this.mode(),
        lang: this.contentlet()?.languageId.toString(),
        'data-language': this.contentlet()?.languageId.toString(),
      };
      this.setDataAttribute(this.elementRef.nativeElement, this.attributes);
    }
  }

  setDataAttribute(el: HTMLElement, attributes: DataSet) {
    Object.entries(attributes).map(([key, value]) => {
      if (!!el && !!key && !!value) {
        this.domService.setAttribute(el, key, value);
      }
    });
  }
}
